import { history } from "./history"
import { routeTemplates } from "./routeTemplates"

import { mapValues } from "lodash"

/**
 * @typedef {Object} RouteAction
 * @property {(...args: any[]) => string} createHref
 * @property {(...args: any[]) => void} replace
 * @property {(...args: any[]) => void} push
 */

/** @type {Record<string, RouteAction>} */
export const navigation = mapValues(routeTemplates, (rt) => {
  return {
    createHref: (...args) => {
      return `#${rt.build(...args)}`
    },
    replace: (...args) => history.replace(rt.build(...args)),
    push: (...args) => history.push(rt.build(...args)),
  }
})
